import { z } from "zod";

export const jobDescriptionSchema = z.object({
  jobTitle: z
    .string({
      required_error: "The job title is required",
      invalid_type_error: "Value must be a string",
    })
    .min(2, {
      message: "Job title must be at least 2 characters.",
    }),
  jobRequirements: z
    .string({
      required_error: "The job requirements are required",
      invalid_type_error: "value must be a string",
    })
    .min(10, {
      message: "Job requirements must be at least 10 characters.",
    }),
  jobCompany: z.string({
    required_error: "The company name  is required",
    invalid_type_error: "value must be a string",
  }),
});
